import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20city%20skyline%20aerial%20view%20at%20dusk%20golden%20hour%20light%20skyscrapers%20urban%20landscape%20panoramic%20wide%20angle%20professional%20photography%20warm%20tones&width=1920&height=700&seq=cta001&orientation=landscape"
          alt="立即開始保障規劃"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F2847]/90 via-[#0F2847]/75 to-[#1a3d6b]/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left */}
          <div className="text-center lg:text-left">
            <p className="text-[#C9A84C] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
              START YOUR JOURNEY
            </p>
            <h2
              className="font-serif font-bold text-white mb-6"
              style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.75rem)', lineHeight: '1.3' }}
            >
              立即開始
              <br />
              <span className="text-[#C9A84C]">您的保障規劃</span>
            </h2>
            <p className="text-white/80 max-w-lg" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
              一次免費的保障諮詢，可能改變您和家人的未來。
              讓我們一起為您的人生築起最堅固的保障基礎。
            </p>
          </div>

          {/* Right */}
          <div className="flex flex-col sm:flex-row lg:flex-col gap-4 flex-shrink-0">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-3 bg-white text-[#0F2847] px-8 py-4 rounded-full font-bold whitespace-nowrap hover:bg-[#C9A84C] hover:text-white transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#0F2847] group-hover:bg-white">
                <i className="ri-calendar-check-line text-white text-sm"></i>
              </div>
              免費預約諮詢
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-3 border-2 border-white/50 text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:border-white hover:bg-white/10 transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-phone-line text-[#C9A84C]"></i>
              </div>
              立即致電諮詢
            </Link>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 pt-12 border-t border-white/15 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: 'ri-shield-check-line', text: '合法持照業務員' },
            { icon: 'ri-award-line', text: '多項專業認證' },
            { icon: 'ri-lock-line', text: '個資安全保護' },
            { icon: 'ri-heart-line', text: '終身服務承諾' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-3 text-white/80">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className={`${badge.icon} text-[#C9A84C] text-xl`}></i>
              </div>
              <span style={{ fontSize: '1.0625rem' }}>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
